<div class="pushpin-move-container">
    @if (customerArea) {
        <div class="content">
            <h1 class="h4 condensed">Delen beheren</h1>
            <div>
                <div>
                    Kies hieronder een schouwronde om de punten naartoe te verplaatsen of kopiëren.
                </div>
                <ng-select
                    (change)="inspectionChanged()"
                    [(ngModel)]="moveToInspection"
                    [items]="customerArea.inspections"
                    bindLabel="name"
                    class="w-100"
                    placeholder="Verplaatsen naar schouwronde">
                </ng-select>
            </div>
            @if (moveToInspection && !selectionEnabled) {
                <div>
                    <button (click)="draw()" class="w-100" mat-stroked-button>
                        Maak een selectie op de kaart
                    </button>
                </div>
            }
            @if (selectionEnabled) {
                <div>
                    <i>Maak een selectievak door met de <b>rechter</b>muisknop op de kaart te klikken.</i>
                </div>
            }
            @if (mapComponent.selectionPolygon()?.length > 2) {
                <div>
                    <div class="pt-2 pb-2">
                        Je hebt {{selectedPushpins?.length}} locaties met {{selectedPushpinParts?.length}} onderliggende delen geselecteerd
                    </div>
                    @if (moveToInspection) {
                        <button (click)="movePoints()" [disabled]="moving || copying" class="w-100 mb-2" mat-stroked-button>
                            @if (moving) {
                                Bezig met verplaatsen van {{selectedPushpinParts?.length}} delen <i class="fas fa-circle-notch fa-spin"></i>
                            } @else {
                                Verplaats {{selectedPushpinParts?.length}} delen
                            }
                        </button>
                    }
                    @if (moveToInspection) {
                        <button (click)="copyPoints()" [disabled]="moving || copying" class="w-100 mb-2" mat-stroked-button>
                            @if (copying) {
                                Bezig met kopiëren van {{selectedPushpinParts?.length}} delen <i class="fas fa-circle-notch fa-spin"></i>
                            } @else {
                                Kopieer {{selectedPushpinParts?.length}} delen
                            }
                        </button>
                    }
                    <button (click)="clearSelection()" [disabled]="moving" class="w-100" color="warn" mat-stroked-button>
                        Selectie van {{selectedPushpins?.length}} punten annuleren
                    </button>
                </div>
            }
        </div>
    }
</div>
